import { useState } from "react";
import { MotionConfig } from "framer-motion";
import { Nav } from "../components/landing/Nav";
import { Hero } from "../components/landing/Hero";
import { Marquee } from "../components/landing/Marquee";
import { Principle } from "../components/landing/Principle";
import { Solutions } from "../components/landing/Solutions";
import { HowItWorks } from "../components/landing/HowItWorks";
import { MobileTool } from "../components/landing/MobileTool";
import { Money } from "../components/landing/Money";
import { Membership } from "../components/landing/Membership";
import { Philosophy } from "../components/landing/Philosophy";
import { Manifesto } from "../components/landing/Manifesto";
import { Faq, Testimonials } from "../components/landing/Faq";
import { Cta } from "../components/landing/Cta";
import { RegisterForm } from "../components/landing/RegisterForm";
import { Footer } from "../components/landing/Footer";
import { INTRO_SEEN_KEY, IntroOverlay } from "../components/landing/IntroOverlay";
import { useLenis } from "../lib/scroll";

export default function Landing() {
  useLenis();
  const [intro, setIntro] = useState(() => !localStorage.getItem(INTRO_SEEN_KEY));
  return (
    <MotionConfig reducedMotion="user">
      <div className="relative" data-testid="landing-page">
        <IntroOverlay open={intro} onClose={() => setIntro(false)} />
        <Nav />
        <main>
          <Hero onPlayIntro={() => setIntro(true)} />
          <Marquee />
          <Principle />
          <Solutions />
          <HowItWorks />
          <MobileTool />
          <Money />
          <Membership />
          <Philosophy />
          <Manifesto />
          <Testimonials />
          <Faq />
          <Cta />
          <RegisterForm />
        </main>
        <Footer />
      </div>
    </MotionConfig>
  );
}
